import React, { useState } from 'react'
import ServiceResultCardComponent from '../../../Components/card/serviceResultCard'
import { applyForService } from '../../../services/service';
import { getUserData } from '../../../Utils/localStorageUtils';
import { useToast } from '../../../hooks/useToast';

const DatalistSection = ({ servicesData = [] }) => {
    const [loading, setLoading] = useState(null); // Track loading per service
    const userData = getUserData()
    const {showSuccess,showError} = useToast()

    const handleApply = async (serviceId) => {
        setLoading(serviceId); // Set loading state for this service
        try {
            const response = await applyForService(userData?._id, serviceId);
            if (response.success) {
                showSuccess("Successfully applied for service!");
            } else {
                showError(response.message || "Failed to apply for service.");
            }
        } catch (error) {
            showError("Something went wrong, please try again.");
        }
        setLoading(null); // Reset loading state
    };


    return (
        <div className="flex flex-col gap-4"> {/* Use flex column layout for vertical arrangement */}
            {servicesData.length > 0 ? (
                servicesData.map((service, index) => (
                    <ServiceResultCardComponent 
                    key={index} 
                    serviceData={service}
                    onApply={handleApply} // Pass function as prop
                    loading={loading === service._id} // Track loading state
                    />
                ))
            ) : (
                <p>No services available.</p> // Placeholder text when no data is available
            )}
        </div>
    )
}

export default DatalistSection
